import { useEffect, useState } from 'react'
import { PosSectionMain } from '../../../components-pos'
import { onlposListPayRecord } from '../../../lib/api-onlpos'
import {
  getPriceStr,
  getTimestampFromNow,
  isJson,
} from '../../../../../lib/utils'
import { CustomTable2 } from '../../../../../components/Tables2'
import { CalendarDropdown } from '../../../../../components/CalendarInput2'
import { BarChart } from '../../../components-pos'
import { debug } from '../../../../../settings'

const testHeader = [
  { name: 'day', displayName: '요일' },
  { name: 'label', displayName: '날짜' },
  { name: 'value', displayName: '금액', type: 'number' },
]

export function ByDate(props) {
  const { shopInfo } = props

  const [records, setRecords] = useState([])

  const _startDate = new Date(
    getTimestampFromNow({ now: new Date(), days: -6 }),
  )
  const _endDate = new Date(getTimestampFromNow({ now: new Date(), days: 0 }))
  const [startDate, setStartDate] = useState(_startDate)
  const [endDate, setEndDate] = useState(_endDate)

  useEffect(() => {
    async function start() {
      try {

        const start_time = new Date(startDate).getTime()
        const end_time0 = new Date(endDate).getTime()
        const end_time = getTimestampFromNow({ now: new Date(end_time0), days: 1 })        

        const diff = end_time - start_time
        if (diff < 0) {
          throw Error('종료일이 시작일보다 빠릅니다.')
        } else if (diff > 10 * 24 * 60 * 60 * 1000) {
          throw Error('최대 10일 까지만 조회할 수 있습니다.')
        }

        let res = await onlposListPayRecord({ shopInfo, start_time, end_time })
        if (res.err) throw Error(res.err.message)
        const payRecordes = parsePayData(res.result.Items)

        if (debug) {
          console.log('-'.repeat(50), 'payRecordes')
          console.table(payRecordes)
          console.log(
            'start',
            start_time,
            new Date(start_time).toLocaleString(),
          )
          console.log('end  ', end_time, new Date(end_time).toLocaleString())
        }

        const newGraphData = createGraphData(payRecordes, start_time, end_time)
        setRecords(newGraphData)
      } catch (e) {
        alert(e.message)
      }
    }
    start()
  }, [startDate, endDate])

  const styles = {
    caledarWrap: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      // justifyContent: "space-around"
    },
    wrap: {
      width: '100%',
      display: 'flex',
    },
  }

  return (
    <PosSectionMain>
      <div style={styles.caledarWrap}>
        <CalendarDropdown
          variant="dark"
          label="Start Date"
          date={startDate}
          setDate={setStartDate}
          // size="min"
        />

        <CalendarDropdown
          variant="dark"
          label="End Date"
          date={endDate}
          setDate={setEndDate}
          // size="min"
        />
      </div>

      <div style={styles.wrap}>
        <div style={{ flex: 1 }}>
          <CustomTable2
            variant="info"
            rowItems={records}
            setRowItems={setRecords}
            tableHeader={testHeader}
          />
        </div>
        <div style={{ flex: 2 }}>
          <BarChart graphData={records} size={{ w: '550', h: '450' }} />
        </div>
      </div>
    </PosSectionMain>
  )
}

function parsePayData(payRecordList) {
  const parsed = payRecordList.map((r) => {
    return {
      ...r,
      orderData: isJson(r.orderData) ? JSON.parse(r.orderData) : null,
      payData: isJson(r.payData) ? JSON.parse(r.payData) : null,
    }
  })
  return parsed
}

function createGraphData(payRecordList, startDate, endDate) {
  const graphData = []
  payRecordList.forEach((record) => {
    const date = new Date(record.created)
    const label = date.toLocaleDateString('ko-KR', {
      month: '2-digit',
      day: '2-digit',
    })
    // const label = date.toLocaleDateString()
    const day = date.toLocaleString('ko-KR', { weekday: 'short' })
    const value = parseInt(record.orderAmt, 10)
    graphData.push({ label, value, day })
  })

  const initialData = []
  let curDate = startDate
  while (endDate > curDate) {
    // console.log('curDate', new Date(curDate).toLocaleDateString())
    const label = new Date(curDate).toLocaleDateString('ko-KR', {
      month: '2-digit',
      day: '2-digit',
    })
    const day = new Date(curDate).toLocaleString('ko-KR', { weekday: 'short' })
    initialData.push({ label, value: 0, day })
    curDate = curDate + 24 * 60 * 60 * 1000 // 하루씩  증가
  }

  // console.table(initialData)

  const groupedData = graphData.reduce((acc, curr) => {
    const existing = acc.find((item) => item.label === curr.label)
    if (existing) {
      existing.value += curr.value
    } else {
      acc.push({ ...curr })
    }
    return acc
  }, initialData)

  // console.table(groupedData)

  return groupedData
}
